module.exports = {"230803001":"西林街道","230803002":"保卫街道","230803003":"桥南街道","230803004":"西南岗街道","230803005":"建设街道","230803006":"长安街道","230803198":"向阳区（镇）直辖地域"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230803.json
// module id = 700
// module chunks = 0